require('./dashboard-audio-player-directive-template.html');
require('./dashboard-audio-player.style.less');

var uploadHeaders = {
  transformRequest: angular.identity,
  headers: { 'Content-Type': undefined },
};

angular.module('bbl.directives.dashboard-audio-player')

.directive('dashboardAudioPlayer', [function() {
  return {
      restrict: 'EA',
      templateUrl: 'dashboard-audio-player-directive-template.html',
      transclude: true,
      scope: {
          bridge: '=',
      },

      controller: ['$scope', '$http', 'Toast', 'ENV', '$timeout', dashboardAudioPlayerCtrl],
      link: function($scope, $el, atts) {},
  };
}]);

function dashboardAudioPlayerCtrl($scope, $http, Toast, env, $timeout) {
  var UPLOAD_SIZE_LIMIT = env.UPLOAD_SIZE_LIMIT;

  $scope.d = {
    file: null,
    uploading: false,
  };

  $scope.$watch('bridge', function(oldv, newv) {
    if (oldv !== newv) {
      $scope.d = {
        file: $scope.bridge.play_in_conference_file || $scope.bridge.play_in_conference_file_name ? {
          name: $scope.bridge.play_in_conference_file_name,
          file: $scope.bridge.play_in_conference_file || '#',
        } : null,
        uploading: false,
      };
    }
  });

  function validateUploadFile(file) {
    var isAudioFile = file.type.match(/audio\/.*/i) || file.name.match(/\.mp3$/i);

    if(!isAudioFile) {
      Toast.error('Only audio files are allowed!');
      return;
    }

    if (file.size > UPLOAD_SIZE_LIMIT) {
      Toast.error('Max upload size limit is 120MB!');
      return;
    }

    return true;
  }

  function uploadFile(file) {
    var fd = new window.FormData();

    fd.append("file", file);
    fd.append("bridge_id", $scope.bridge.id);
    fd.append("type", 'y');

    $scope.d.uploading = true;

    Toast.notify("Uploading file, please wait...", {uid: 'upload-conf-audio-file'});

    return $http.post('/bridges/upload-file', fd, uploadHeaders).then(function(response) {
      var file = {
        id: response.data.id,
        url: response.data.url,
        name: response.data.name,
      };

      Toast.notify("File uploaded successfully!", {uid: 'upload-input-file'});
    }, function() {
      $scope.d.file = null;
      Toast.error('Something went wrong!');
    }).then(function() {
      $scope.d.uploading = false;
    });
  }

  $scope.$watch('d.file', function() {
    var file = $scope.d.file;

    if (!file || typeof file !== 'object' || file.constructor.name !== 'File') {
      return;
    }

    if (!validateUploadFile($scope.d.file)) {
      $scope.d.file = null;
      return;
    }

    uploadFile($scope.d.file);
  });

  $scope.playback = function(action) {
    $http.post('/bridges/api/v1/'+action+'/'+$scope.bridge.id+'/', {}).then(function(response) {
      Toast.notify('Conference playback '+action+'ed!', {uid: 'conference-playback'});
    }, function() {
      Toast.error('Couldn\'t '+action+' conference audio playback!');
    });
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/dashboard-audio-player/dashboard-audio-player.directive.js
 ** module id = 341
 ** module chunks = 0
 **/